import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnFilterClickCharge(props) {
  let current = useDataValue({
    context: 'tab',
    path: 'selected.ledger.notes.filter_by',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.notes.filter_by',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (current.length === 0) {
      change(['charge'])
      return
    }

    if (current.includes('charge')) {
      let newSelected = current.filter(item => item !== 'charge')
      change(newSelected)
    } else {
      change([...current, 'charge'])
    }
  }
}

export function getCount(notes, type) {
  return notes.filter(item => item.type === type).length
}
